/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react';
import type { ContentChangeListener } from '@volkswagen-onehub/audi-content-service';

import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import type { AppContent, FeatureAppProps } from '../@types/interfaces';

import { EditorialText } from './components/EditorialText';
import { normalizeContent } from './components/normalizeContent';

import mockContent from './content.json';
import { getNextId } from '../utils/getNextId';

const FeatureApp: React.FC<FeatureAppProps> = ({ ...inherited }: FeatureAppProps) => {
  const {
    contentService,
    trackingService: trackingServiceInherited,
    footnoteReferenceService,
    vueFormatterService,
    localeService,
  } = inherited;

  let trackingService = {} as TrackingServiceV2;

  if (typeof window !== 'undefined') {
    trackingService = trackingServiceInherited!;
  }

  const [rawContent, setRawContent] = useState(contentService?.getContent() as AppContent);
  contentService?.onContentChange(setRawContent as ContentChangeListener);

  useEffect(() => {
    const featureAppId = trackingService?.featureAppId ?? getNextId(__FEATURE_APP_NAME__);

    trackingService.featureAppName = 'editorial-text';
    const additionalObjects = {
      componentInfo: {
        componentID: featureAppId,
      },
      attributes: {
        implementer: 2,
        version: __FEATURE_APP_VERSION__,
      },
    };

    const dataLayerEvent = {
      eventInfo: {
        eventAction: 'feature_app_ready',
        eventName: 'editorial text - feature app ready',
      },
      attributes: {
        componentName: 'editorial-text',
        label: '',
        targetURL: '',
        clickID: '',
        elementName: '',
        value: '',
        pos: '',
      },
    };
    trackingService.track({ event: dataLayerEvent, componentUpdate: additionalObjects });
  }, []);

  useEffect(() => {
    const listener = () => {
      setRawContent(normalizeContent(contentService.getContent() as AppContent));
    };

    contentService.onContentChange(listener);

    return () => {
      contentService.removeOnContentChange(listener);
    };
  }, [contentService, setRawContent]);

  const content = normalizeContent(rawContent ?? mockContent);

  return (
    <EditorialText
      content={content}
      footnoteReferenceService={footnoteReferenceService}
      vueFormatterService={vueFormatterService}
      localeService={localeService}
      trackingService={trackingService}
    />
  );
};

export default FeatureApp;
